import Vue from "vue"
import store from "@/store"
import { MVT_EVENTS } from "@/sdk/event-manager"

const trackGTMEvent = (event: string, data: object): void => {
  const gtm = (Vue as any).gtm

  if (!gtm || !gtm.enabled()) return

  let trackedData = data

  if (!("user" in data)) {
    const currentUser = store.getters["auth/currentUser"]

    trackedData = {
      ...trackedData,
      user: currentUser?.subscriberUuid
        ? { id: currentUser?.subscriberUuid }
        : null
    }
  }

  gtm.trackEvent({
    event,
    ...trackedData
  })
}

export const isTrackedDownloadLink = (url: string): boolean =>
  /\.(pdf|docx?|xlsx?|zip|rar|csv|pptx?)$/i.test(url)

type EventSubscriptionSource = {
  on: (event: string, callback: (payload: any) => void) => void
}

type GtmIntegrationOptions = {
  eventManager?: EventSubscriptionSource
  events?: string[]
}

const GTM_COMPAT: Record<string, string> = {
  [MVT_EVENTS.PAGE_VIEW]: "custom_page_view"
}

let gtmIntegrationInitialized = false

export const setupGTMIntegration = ({
  eventManager,
  events = []
}: GtmIntegrationOptions = {}) => {
  if (gtmIntegrationInitialized) return
  if (!eventManager || events.length === 0) return

  const gtm = (Vue as any).gtm
  if (!gtm || !gtm.enabled()) return

  gtmIntegrationInitialized = true

  events.forEach(eventName => {
    eventManager.on(eventName, (payload: any) => {
      // Check GTM compatibility mapping
      if (eventName in GTM_COMPAT) {
        trackGTMEvent(GTM_COMPAT[eventName], payload)
      } else {
        trackGTMEvent(eventName, payload)
      }
    })
  })
}
